module.exports = {
    locale_name: 'English',
    locale_shorthand: ['en', 'english'],
    // Translations:
    justifyCenter: 'Center',
    justifyLeft: 'Justify Left',
    justifyRight: 'Justify Right',
    bold: 'Bold',
    code: 'Code',
    headings: 'Headings (h1-h6)',
    link: 'Hyperlink',
    image: 'Insert Image',
    italic: 'Italic',
    orderedList: 'Ordered List (1, 2, 3, ...)',
    unorderedList: 'Bullet List',
    removeFormat: 'Remove formatting.\nClears headings, bold, italic, underlined text, etc.',
    separator: null,
    table: 'Insert Table',
    underline: 'Underline'
}